import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

import { HubspotFormDialogComponent } from './hubspot-form-dialog.component';

/**
 * Module for the HubSpot form dialog component
 *
 * Note: The HubspotFormDialogService is provided at the root level
 * in the service file itself, so it doesn't need to be provided here.
 */
@NgModule({
  declarations: [
    HubspotFormDialogComponent,
  ],
  imports: [
    CommonModule,
    MatDialogModule,
    MatButtonModule,
    MatIconModule,
  ],
  exports: [
    HubspotFormDialogComponent,
  ],
})
export class HubspotFormDialogModule { }
